import { request } from '@/shared/api/request'

export const setStaffingBranch = (bin) => {
	return request({ url: `staff/save/currentBin/${bin}`, method: 'POST' })
}